import { ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/system";

interface FormToggleButtonGroupProps {}

export const FormToggleButtonGroup = styled(ToggleButtonGroup, {
    name: 'MuiFormToggleButtonGroup',
})<FormToggleButtonGroupProps>(({theme}) => ({
    gap: '0.5rem',

    '& .MuiToggleButton-root': {
        borderRadius: '0.5rem',
        border: 0,
        height: '32px',

        '&.MuiToggleButton-sizeSmall': {
            borderRadius: '0.5rem',
            textTransform: 'none',
            paddingRight: '0.75rem',
            paddingLeft: '0.75rem',
            fontWeight: 500,
            fontSize: '0.875rem',
        },
    },
}));